// @ts-nocheck
// @mui
import { useTheme } from '@mui/material/styles';
import { Grid, Container, Typography } from '@mui/material';
// components
import Page from '../../components/Page';
// sections
import { AppCurrentVisits, AppWebsiteVisits } from '../../sections/@dashboard/app';
import { useGetAdminDashboardDataMutation } from '../../store/api/dashboardApi';
import { useEffect, useState } from 'react';
import {
  getDashboardcityWiseDataStore,
  getDashboardgraphDataStore,
  setDashboardDataStore,
} from '../../store/state/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { useGetRevenueDataMutation } from '../../store/api/revenueApi';
import { setRevenue } from '../../store/state/revenueSlice';
import moment from 'moment';
import {
  checkPermissions,
  getEndDate,
  getStartDate,
  GET_REVENUE_TABDATA,
} from '../../sections/@dashboard/parkingspaces/utility';
import { PERMISSION } from '../../utils/userPermission';
import Loading from '../../components/Loading';

// ----------------------------------------------------------------------

export default function DashboardAdminApp() {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  let currentDate = new Date();
  currentDate.setMonth(currentDate.getMonth() - 1);
  const getDashboardGraphData = useAppSelector(getDashboardgraphDataStore);
  const getDashboardCityWiseData = useAppSelector(getDashboardcityWiseDataStore);
  const [completedList, setCompletedList] = useState([]);
  const [monthList, setMonthList] = useState([]);
  const [currentList, setCurrentList] = useState([]);
  const [cancelList, setCancelList] = useState([]);
  const [cityList, setCityList] = useState([]);
  let toDate = new Date();
  const [getAdminDashboardData, getAdminDashboardDataResponse] = useGetAdminDashboardDataMutation();
  const token = JSON.parse(localStorage.getItem('login') || '{}') || null;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const [getRevenueData, revenueResponse] = useGetRevenueDataMutation();
  const [revenues, setRevenues] = useState([]);

  let day1 = new Date();
  let day7 = moment().startOf('week').toDate();
  let day30 = moment().endOf('week').toDate();
  day30 = day30.toISOString();

  useEffect(() => {
    getRevenueData({
      token: token.token,
      payload: {
        offset: rowsPerPage,
        page: page,
        fromDate: getStartDate(GET_REVENUE_TABDATA[2]),
        toDate: getEndDate(GET_REVENUE_TABDATA[2]),
        isDisputed: 'false',
        orderBy: 'id',
        orderDir: 'desc',
      },
    });
  }, []);

  useEffect(() => {
    if (revenueResponse.isSuccess) {
      dispatch(setRevenue(revenueResponse.data.revenueData));
      setRevenues(revenueResponse.data.revenueData);
    }
  }, [revenueResponse.isSuccess]);

  useEffect(() => {
    getAdminDashboardData({
      token: token.token,
      payload: {
        fromDate: currentDate,
        toDate: toDate,
      },
    });
  }, []);

  useEffect(() => {
    if (getAdminDashboardDataResponse.isSuccess) {
      dispatch(setDashboardDataStore(getAdminDashboardDataResponse.data));
    }
  }, [getAdminDashboardDataResponse.isSuccess]);

  useEffect(() => {
    if (getDashboardGraphData) {
      let month = [];
      let completed = [];
      let current = [];
      let cancel = [];
      getDashboardGraphData.map((item: any) => {
        month.push(item.month);
        completed.push(item.completedBookingCount);
        current.push(item.currentBookingCount);
        cancel.push(item.cancelledBookingCount);
      });
      setMonthList(month);
      setCompletedList(completed);
      setCurrentList(current);
      setCancelList(cancel);
    }
  }, [getDashboardGraphData]);

  useEffect(() => {
    if (getDashboardCityWiseData) {
      let city = [];
      getDashboardCityWiseData.map((item: any) => {
        // value.push(item.bookingCount);
        city.push({ label: item.cityName, value: item.bookingCount });
      });
      setCityList(city);
    }
  }, [getDashboardCityWiseData]);

  return (
    <Page title="Dashboard">
      <Container maxWidth="xl">
        <Typography variant="h4" sx={{ mb: 5 }}>
          Hi, Welcome back
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <AppWebsiteVisits
              title="Total Bookings"
              chartLabels={monthList}
              chartData={[
                {
                  name: 'Current',
                  type: 'column',
                  fill: 'solid',
                  data: currentList,
                },
                {
                  name: 'Completed',
                  type: 'area',
                  fill: 'gradient',
                  data: completedList,
                },
                {
                  name: 'Cancelled',
                  type: 'line',
                  fill: 'solid',
                  data: cancelList,
                },
              ]}
            />
          </Grid>

          {checkPermissions(PERMISSION.DASHBOARD_24_HR_DATA, token.permissions) ? null : (
            <Grid item xs={12} md={6}>
              <AppCurrentVisits
                title="Bookings by City"
                chartData={cityList}
                from="city"
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.chart.red[0],
                  theme.palette.chart.yellow[1],
                  theme.palette.chart.violet[0],
                ]}
              />
            </Grid>
          )}
          {checkPermissions(PERMISSION.DASHBOARD_24_HR_DATA, token.permissions) ? null : (
            <Grid item xs={12} md={6}>
              <AppCurrentVisits
                title="Revenue by Source"
                chartData={revenues}
                from="revenues"
                chartColors={[
                  theme.palette.primary.main,
                  theme.palette.chart.red[0],
                  theme.palette.chart.yellow[1],
                  theme.palette.chart.violet[0],
                ]}
              />
            </Grid>
          )}
        </Grid>
        {getAdminDashboardDataResponse.isLoading || revenueResponse.isLoading ? <Loading /> : null}
      </Container>
    </Page>
  );
}
